import ItensMenu from './ItensMenu';
import './Sidebar.css';
import SidebarFooter from './SidebarFooter';
import SidebarHeader from './SidebarHeader';

const Silebar = (props) => {
    const { close } = props;
    
    return(
        <aside className={`sidebar ${close ? "collapsed" : ""}`} id="sidebar">
            
            <SidebarHeader />

            <nav className="sidebar-menu">
                
                <ItensMenu active={props.dashboardActive} icone="🏠" nome="Dashboard" link="/dashboard"/>
                <ItensMenu active={props.dadosBancariosActive} icone="🏦" nome="Dados bancários" link="/dadosbancarios"/>
                <ItensMenu icone="➕" nome="Cadastrar leads" link="/embreve"/>
                <ItensMenu active={props.extratoActive} icone="📄" nome="Extrato" link="/extrato"/>
                <ItensMenu active={props.ajudaActive} icone="❓" nome="Ajuda / FAQ" link="/ajuda"/>
                
            </nav>

            <SidebarFooter />
        </aside>
    );
};

export default Silebar;

